export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7377.84b98669.jpg";